import WebStorage from "@adapters/infrastructures/WebStorage";
import CookieStorage from "@adapters/infrastructures/CookieStorage";
export default (function () {
    return {
        localStorage: new WebStorage(window.localStorage),
        cookieStorage: new CookieStorage(document.cookie),
        sessionStorage: new WebStorage(window.sessionStorage),
    };
});
